import { render, staticRenderFns } from "./EditCourseVideo.vue?vue&type=template&id=27140d4e&scoped=true"
import script from "./EditCourseVideo.vue?vue&type=script&lang=js"
export * from "./EditCourseVideo.vue?vue&type=script&lang=js"
import style0 from "./EditCourseVideo.vue?vue&type=style&index=0&id=27140d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27140d4e",
  null
  
)

export default component.exports